var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cpt-role-item"},[_c('RoleAvatar',{attrs:{"img":_vm.role.icon,"color":_vm.isGradient
        ? _vm.role.color_list.map((c) => _vm.decimalToHexColor(c)).join(',')
        : _vm.decimalToHexColor(_vm.role.color),"gradient":_vm.isGradient,"size":"middle","icon":_vm.role.type == _vm.ROLE_TYPES.everyone ? 'icon-friends-request' : 'icon-admin'}}),_c('span',{directives:[{name:"emoji-html",rawName:"v-emoji-html",value:({text: _vm.role.name, style: {width: `${_vm.nameSize}px`}}),expression:"{text: role.name, style: {width: `${nameSize}px`}}"}],staticClass:"role-name",class:{
      'gradient-text': _vm.isGradient,
    },style:({
      color: _vm.isGradient ? '' : _vm.role.color,
      'background-image': _vm.isGradient
        ? `linear-gradient(90deg, ${_vm.decimalToHexColor(
            _vm.role.color_list[0]
          )} 0%, ${_vm.decimalToHexColor(_vm.role.color_list[1])} 100%)`
        : '',
      'font-size': _vm.nameSize + 'px',
    })}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }